(() => {
  'use strict';
  const all = s => [...document.querySelectorAll(s)];
  const language = document.documentElement.lang.toLowerCase().split('-')[0] === 'ms' ? 'ms' : 'en';
  const menu = document.querySelector('#menu-toggle');
  const navigation = document.querySelector('#main-nav');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function updateReadingTools() {
    const body = document.querySelector('.article-body');
    if (!body) return;
    const active = body.querySelector(`.lang-copy[lang="${language}"]`) || body;
    const toc = document.querySelector('#article-toc');
    const list = toc?.querySelector('ol');
    const headings = [...active.querySelectorAll('h2')];
    if (list) {
      list.replaceChildren();
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = `guide-${language}-${i + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link); list.append(item);
      });
      toc.hidden = headings.length < 2;
    }
    const time = document.querySelector('.reading-time');
    if (time) {
      const minutes = Math.max(1, Math.ceil(active.textContent.trim().split(/\s+/).length / 200));
      time.textContent = language === 'en' ? ` · ${minutes} min read` : ` · ${minutes} minit bacaan`;
    }
  }
  all('.lang-copy').forEach(el => { el.hidden = el.lang !== language; });
  updateReadingTools();
  function closeMenu() { navigation?.classList.remove('open'); menu?.setAttribute('aria-expanded', 'false'); }
  menu?.addEventListener('click', () => { const open = navigation?.classList.toggle('open'); menu.setAttribute('aria-expanded', String(Boolean(open))); });
  navigation?.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && navigation?.classList.contains('open')) { closeMenu(); menu?.focus(); } });
  document.addEventListener('click', e => { if (!e.target.closest('.header')) closeMenu(); });
  all('#main-nav a').forEach(link => { const target = new URL(link.href, location.origin); if (target.pathname !== '/' && target.pathname !== '/ms' && target.pathname !== '/ms/' && location.pathname.startsWith(target.pathname)) link.setAttribute('aria-current', 'page'); });
  const input = document.querySelector('#search');
  const cards = all('.destination[data-keywords]');
  let category = 'all';
  function filterDestinations() {
    const terms = (input?.value || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
    let count = 0;
    cards.forEach(card => { const show = (category === 'all' || card.dataset.tags.split(' ').includes(category)) && terms.every(term => card.dataset.keywords.includes(term)); card.hidden = !show; if (show) count++; });
    const empty = document.querySelector('#no-results'); if (empty) empty.hidden = count !== 0;
    const status = document.querySelector('#results-status'); if (status) status.textContent = count + (language === 'en' ? ' destinations found' : ' destinasi ditemui');
  }
  all('[data-filter]').forEach(button => button.addEventListener('click', () => { category = button.dataset.filter; all('[data-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button))); filterDestinations(); }));
  input?.addEventListener('input', filterDestinations);
  document.querySelector('#search-form')?.addEventListener('submit', e => { e.preventDefault(); filterDestinations(); document.querySelector('#destinations')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' }); });
  document.querySelector('#reset')?.addEventListener('click', () => { if (input) input.value = ''; category = 'all'; all('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === 'all'))); filterDestinations(); });
})();



(() => {
  const article = document.querySelector('.journal-article');
  if (!article) return;
  const toc = article.querySelector('.journal-toc');
  if (toc && matchMedia('(max-width: 900px)').matches) toc.open = false;
  const button = article.querySelector('.journal-copy-link');
  const status = article.querySelector('.journal-share-status');
  button?.addEventListener('click', async () => {
    const ms = document.documentElement.lang === 'ms';
    try {
      const url = document.querySelector('link[rel="canonical"]')?.href || location.href.split('#')[0].split('?')[0];
      await navigator.clipboard.writeText(url);
      status.textContent = ms ? 'Pautan artikel disalin.' : 'Article link copied.';
    } catch {
      status.textContent = ms ? 'Salin alamat artikel daripada bar alamat pelayar.' : 'Copy the article address from your browser’s address bar.';
    }
  });
  const bar = article.querySelector('.journal-progress > span');
  const body = article.querySelector('.article-body');
  let pending = false;
  function updateProgress() {
    pending = false;
    if (!bar || !body) return;
    const distance = Math.max(1, body.offsetHeight - innerHeight);
    const value = Math.max(0, Math.min(1, -body.getBoundingClientRect().top / distance));
    bar.style.transform = 'scaleX(' + value + ')';
  }
  function scheduleProgress() {
    if (!pending) { pending = true; requestAnimationFrame(updateProgress); }
  }
  addEventListener('scroll', scheduleProgress, { passive: true });
  addEventListener('resize', scheduleProgress);
  function languageChanged() { if (status) status.textContent = ''; scheduleProgress(); }
  updateProgress();
})();
